import { ContainerElement, LayoutElement } from "@entaconsulting/form";

const resolveLayoutElement = (
  elements: LayoutElement[],
  routeToElement: string[]
): LayoutElement => {
  const currentElementIndex: number = +routeToElement[0];
  const currentElement = elements[currentElementIndex];
  const nextRoute = routeToElement.slice(1);
  if (nextRoute.length !== 0) {
    const containerElement = currentElement as ContainerElement;
    return resolveLayoutElement(containerElement.elements, nextRoute);
  }
  return currentElement;
};

export default resolveLayoutElement;
